module.exports = __webpack_public_path__ + "static/media/programa372.5815a4cc.jpg";